<template>
    <input :class="quickSearchInputClass"
           type="text"
           :placeholder="quickSearchInputPlaceholder"
           :aria-label="quickSearchInputLabel"
           v-model="searchValue"
           v-on:keyup.enter="onEnter">
</template>
<script>
    export default {
        data: () => {
            return {
                searchValue: null
            }
        },
        computed: {
            quickSearchInputClass() {
                return "form-control form-control-dark w-100";
            },
            quickSearchInputPlaceholder() {
                return "Search";
            },
            quickSearchInputLabel() {
                return "Search";
            }
        },
        methods: {
            onEnter() {
                this.$emit("quick-search-enter", this.searchValue)
                this.searchValue = null
            }
        }
    }
</script>